import BeelditFileInput from "@beeldit/core/components/BeelditFileInput";
import BeelditTypeSelector from "@beeldit/core/components/BeelditTypeSelector";

const widgets: any = {
  "type-selector": BeelditTypeSelector,
  "file-input": BeelditFileInput,
};

export default widgets;
